import SearchResults from "./SearchResults";
import SearchProvider from "../provider/SearchProvider";
import SearchBox from "./SearchBox";

export type SearchWidgetModel = {
  pageSize: number,
  resultMessage: string,
  noResultMessage: string
}

export default function SearchWidget({ pageSize, resultMessage, noResultMessage }: SearchWidgetModel) {
  return (
    <SearchProvider pageSize={pageSize}>
      <SearchBox />
      <SearchResults resultMessage={resultMessage} noResultMessage={noResultMessage} />
    </SearchProvider>
  )
}